import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import GavelIcon from "@mui/icons-material/Gavel";
import EmailSignupModal from "./EmailSignupModal";
import prioritiesImage1 from "../images/strengthening-education.png";
import prioritiesImage1b from "../images/strengthening-education.png";
import prioritiesImage1c from "../images/strengthening-education.png";
import prioritiesImage2 from "../images/strengthening-education.png";
import prioritiesImage3 from "../images/strengthening-education.png";
import prioritiesImage4 from "../images/strengthening-education.png";
import targetImage from "../images/prioritiesHeader.jpg";
import { AssuredWorkload, Engineering, LocalAirport, LocalPolice, School, Traffic } from "@mui/icons-material";
const Priorities = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#FFFDF7!important" }}>
      {/* Header */}
      <Box
        sx={{
          backgroundImage: `url(${targetImage})`,
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "left" : "center",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          Issues
        </Typography>
      </Box>
      {/* Body */}
      <Box
        p={isMobile ? "0 16px" : "96px 96px 48px"}
        sx={{ background: "#014991" }}
        className="priorities-page-wrap"
      >
        <Grid container alignItems="flex-start">
          {/* Advocating for Our Communities */}
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
            >
              <Engineering
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Smarter Development
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Development in our county must be smarter. We need to
                concentrate growth by metro stops and make sure developers pay
                their fair share for the cost of infrastructure improvements and
                school construction. We need to make sure new development is
                done in a way that does not overstress our roads as traffic in
                our area is already bad enough. Brookeville residents deserve a
                leader that will promote a ZTA to ensure that drug
                rehabilitation centers stay away from our schools and our
                children.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Expanding Economic Opportunity*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                  textWrap: "nowrap",
                }}
              >
                Montgomery County Airpark
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                The Montgomery Airpark has been a part of our community since
                1960. County residents have benefited from the Airpark both
                economically and socially. Recently, public safety and community
                concerns have contributed to stakeholders having meetings with
                no substantive solutions. A lack of political leadership,
                coupled with multiple stakeholders having a variety of
                individual agendas have contributed to a lack of mutual
                cooperation and trust. I’ve been flying out of the Airpark since
                1998. I have the knowledge, experience and personal
                relationships with the stakeholders to ensure progress is made
                to building a more harmonious relationship between airport
                stakeholders and the residential community at large.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
               <LocalAirport
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>
          </Grid>
          {/* Strengthening Our Education System */}
          <Grid container className="section-wrap" mb={3} display={"flex"}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
            >
              <School
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Education
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Our children deserve the opportunity to thrive. We need to make
                sure our schools can hire and retain the best teachers and that
                our students learn in classrooms, not trailers. That’s why
                ensuring funding for our public schools will be my top priority
                on the County Council. I will fight to ensure developers pay
                their fair share, so that when more students enter our schools,
                there is additional money provided to make sure all our kids are
                educated and that our schools don’t become even more
                overcrowded. Damascus and Magruder High Schools are both overdue
                for renovation.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Keeping Our Communities Safe*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                  textWrap: "nowrap",
                }}
              >
                Public Safety
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                As a retired police officer and a parent, I know that every
                person deserves to feel safe where they live and work. So
                keeping our communities safe is a top priority. I will support
                funding after-school programs to keep our kids off the streets
                and out of trouble. I will support community policing
                initiatives that allow public safety officers to work together
                with the community to prevent crime and keep us safe. Police
                Officers deserve a collective bargaining agreement that supports
                our officers and their families. Our Officers have been stripped
                of many protections that need to be restored in order to retain
                and recruit our beloved officers.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <LocalPolice
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>
          </Grid>
          {/* Improving Our Transportation &amp; Infrastructure */}
          <Grid container className="section-wrap" mb={3}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
            >
              <Traffic
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Traffic
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                There is nothing more frustrating than dealing with traffic.
                Unfortunately, the County has made decisions to make traffic
                worse and has applied collective punishment to motorists.
                Predatory revenue generating speed cameras, non data driven “No
                turn on red signs” and the arbitrary and artificial reduction of
                speed limits have contributed to the increase in traffic. I will
                be advocating for the removal of No turn on red signs that were
                not data justified in District 7. I will advocate for
                non-punitive traffic calming devices vs. supporting revenue
                generating speed cameras that have only contributed to more
                financial loss for our residents. I will also work with our
                labor unions to maximize telework options to minimize employees
                from participating in a daily commute.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Caring for Our Seniors*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFFDF7!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
   
                }}
              >
                Standing up for Our Democracy and Federal Workers
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",
                  color: "white!important",
                }}
              >
                Our County must stand firm against the Trump Administration’s
                attacks on our democracy and our federal workers. We need to
                safeguard voting rights, protect our immigrant communities and
                provide support for the federal workers who have been wrongfully
                terminated.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <AssuredWorkload
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#106cb7!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/SharifHidayat320/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/votesharif2026"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/VoteSharifDistrict7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Sharif Hidayat; Cody Hidayat, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default Priorities;
